import styled from 'styled-components';
import { VisualPickerButtonContainer } from '../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';

export const WorkflowTileButton = styled(VisualPickerButtonContainer)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: 24,
  justifyContent: 'center',
  position: 'relative',
  minHeight: 172,
});
